import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resetuje scroll do (0,0) przy każdej zmianie pathname. Bez tego
 * SPA dziedziczy scroll z poprzedniej strony — np. wejście w Politykę
 * z dolnej części Settings otwiera Politykę przewinięta o tę samą
 * wysokość.
 *
 * Renderowany raz w drzewie Routes (nic nie zwraca, tylko side-effect).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
